<template>
    <c-row>
        <c-col col="6">
            <c-card>
                <c-card-header>
                    <strong>Add Unit</strong>
                </c-card-header>
                <c-card-body>
                    <c-form>
                        <div class="form-group form-row">
                            <label for="unit" class="col-form-label col-sm-3">Name</label>
                            <div class="col-md-9">
                                <input type="text" class="form-control" v-bind:class="{'has-error': hasError.unit}"
                                       v-model="unit.unit" placeholder="Unit" id="unit"/>
                            </div>
                        </div>
                    </c-form>
                </c-card-body>
                <c-card-footer>
                    <sur-button :object="unit" @onSave="save" @onUpdate="update" @onReset="reset"/>
                </c-card-footer>
            </c-card>
        </c-col>
    </c-row>
</template>

<script>
    import {HTTPAUTH} from "../../lib/httplib";
    import SURButton from "../../components/SURButton";

    export default {
        name: "Add",
        components: {
            'sur-button': SURButton,
        },
        data() {
            return {
                unit: {},
                hasError: {}
            }
        },
        created() {
            const query = this.$route.query;
            if (query.id) {
                this.get(query.id)
            }
        },
        methods: {
            get(id) {
                HTTPAUTH.get("/api/v1/unit/" + id).then(res => {
                    this.unit = res.data.data;
                })
            },
            save() {
                HTTPAUTH.post("/api/v1/unit", this.unit).then(() => {
                    this.$toasted.success("Berhasil disimpan").goAway(1000);
                    this.reset();
                }).catch(eres => {
                    this.$toasted.error(eres.response.data.message).goAway(3000);
                    this.hasError = eres.response.data.error;
                })
            },
            update() {
                HTTPAUTH.put("/api/v1/unit/" + this.unit.id, this.unit).then(() => {
                    this.$toasted.success("Berhasil disimpan").goAway(1000);
                    this.reset();
                }).catch(eres => {
                    this.$toasted.error(eres.response.data.message).goAway(3000);
                    this.hasError = eres.response.data.error;
                })
            },
            reset() {
                this.unit = {};
                this.$router.push({query: {}})
            },
        }
    }
</script>

<style scoped>

</style>
